// Header and userAgent are added by Datadog on synthetic tests
// See https://docs.datadoghq.com/synthetics/guide/identify_synthetics_bots/?tab=browsertests
export const isSyntheticTest = (): boolean => {
  return (
    window._DATADOG_SYNTHETICS_BROWSER !== undefined ||
    window.navigator.userAgent.endsWith('DatadogSynthetics')
  );
};
